import { IdTutorialFocusElement } from "../IdTutorialFocusElement";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialConstructClickBuildingMenu = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.constructWindmill_clickBuildMenu) {
        return undefined;
    }
    var hasFocusId = nextTutorialStepConfig.focusId != undefined;
    var hasBuildingId = tutorialStepConfig.buildingId !== undefined;
    if (!hasFocusId || !hasBuildingId) {
        return undefined;
    }
    if (tutorialStepConfig.focusId === IdTutorialFocusElement.button_building_menu ||
        nextTutorialStepConfig.focusId !== IdTutorialFocusElement.button_building_menu) {
        return undefined;
    }
    return path;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialConstructClickBuildingMenu.ts
// module id = 2488
// module chunks = 3